import { LogglyTracker } from "loggly-jslogger";

/* Setup loggly */
const logglyTracker = new LogglyTracker();
logglyTracker.push({
  logglyKey: process.env.LOGGLY_TOKEN,
  sendConsoleErrors: true,
});
const logger: any = {};
const _pushLog = (level, header, data) => {
  const timestamp = new Date();
  const log = {
    header,
    level,
    timestamp: timestamp.getTime(),
    timestampStr: timestamp.toISOString(),
    url: window.location.href,
    ...data,
  };
  logglyTracker.push(log);
};

/**
 * Push an error log to Loggly.
 * @param {string} header // The header will identify an error type.
 * @param {any} data // Could be an object, a number, a string, or any data type.
 * @example
 *   logger.error('USER_CONNECTING', {
 *    userId: 24,
 *    message: 'Error connecting to opentok',
 *    errorCode: 1600,
 *   });
 * */
logger.error = (header, data) => _pushLog("error", header, data);

/**
 * Push an info log to Loggly.
 * @param {string} header // The header will identify an error type.
 * @param {any} data // Could be an object, a number, a string, or any data type.
 * @example
 *   logger.info('USER_LOGOUT', {
 *    userId: 24,
 *    message: 'User clicked on the logout link'
 *   });
 * */
logger.info = (header, data) => _pushLog("info", header, data);

logger.headers = {
  GENERAL_ERROR: "GENERAL_ERROR",
  INIT_PUBLISH_ERROR: "INIT_PUBLISH_ERROR",
  PUBLISH_ERROR: "PUBLISH_ERROR",
  CONNECT_ERROR: "CONNECT_ERROR",
  SUBSCRIBE_ERROR: "SUBSCRIBE_ERROR",
  INIT_PUBLISH_SCREEN_ERROR: "INIT_PUBLISH_SCREEN_ERROR",
  SCREEN_SHARE_ERROR: "SCREEN_SHARE_ERROR",
  SESSION_TRACE: "SESSION_TRACE",
  LOCAL_REC_UPLOAD_ERROR: "LOCAL_REC_UPLOAD_ERROR",
  LOCAL_REC_ERROR: "LOCAL_REC_ERROR",
};

export default logger;
